//
// Generated class LocationAsset
//

/// <reference path="LocationAsset_ManagedObject.ts" />

class LocationAsset extends LocationAsset_ManagedObject
{

}
